<div class="records-page searches-page">
    <div class="searches-page__header">
        <div class="dv-custom-navs">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" (activeIdChange)="onTabChange($event)" class="nav-tabs details-nav-tabs">
                <li [ngbNavItem]="1" [class.rm-tab-active]="active === 1">
                    <a ngbNavLink>
                        <i-feather name="save"></i-feather><label>{{ 'SAVED_SEARCHES' | translate }}</label>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="searches-tab-page records-page datatable-page-shell">
                            <div class="records-page__hero searches-tab-hero">
                                <div class="records-page__hero-primary">
                                    <div class="records-page__hero-headline">
                                        <span class="records-page__hero-eyebrow">{{ 'SEARCHES' | translate }}</span>
                                        <h3 class="records-page__hero-title">{{ 'YOUR_SAVED_SEARCHES' | translate }}</h3>
                                    </div>
                                </div>
                                <div class="records-page__hero-aside" *ngIf="doWhat.isAdmin || doWhat.canCreate">
                                    <div class="records-page__hero-actions">
                                        <button type="button" class="blue-button" (click)="onCreateSearch()">{{ 'CREATE_SEARCH' | translate }}</button>
                                    </div>
                                </div>
                            </div>

                            <div class="details-tab-surface details-tab-surface--tight searches-tab-surface datatable-page-surface">
                                <app-saved-searches></app-saved-searches>
                            </div>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2" [class.rm-tab-active]="active === 2">
                    <a ngbNavLink>
                        <i-feather name="file-plus"></i-feather><label>{{ mode | translate }}</label>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="searches-tab-page records-page datatable-page-shell">
                            <div class="records-page__hero searches-tab-hero">
                                <div class="records-page__hero-primary">
                                    <div class="records-page__hero-headline">
                                        <span class="records-page__hero-eyebrow">{{ 'SEARCHES' | translate }}</span>
                                        <h3 class="records-page__hero-title">{{ mode | translate }}</h3>
                                    </div>
                                </div>
                            </div>

                            <div class="details-tab-surface searches-tab-surface datatable-page-surface">
                                <app-new-search-main (searchSaved)="searchSaved()"></app-new-search-main>
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>
            <div class="details-nav-outlet" [ngbNavOutlet]="nav"></div>
        </div>
    </div>
</div>
